import ApplicationController from './application_controller.js'
import { getPathWithParams } from '../utils/url_helpers'

export default class extends ApplicationController {
  static targets = ['name', 'path']
  static values = { name: String }

  nameTargetConnected() {
    this.nameTarget.value = this.nameValue
  }

  pathTargetConnected() {
    this.pathTarget.value = getPathWithParams()
  }
}
